import cloneDeep from 'lodash.clonedeep';
import newListAddItem from '../../../utils/newListAddItem';
import { newListRemoveItemFlag } from '../../../utils/newListRemoveItem';
import newListUpdateItemFlag from '../../../utils/newListUpdateItem';
import newListUndoItem from '../../../utils/newListUndoItem';
import handleRequest from '../../../utils/handleRequest';
import mapByAttribute from '../../../utils/mapByAttribute';
import initialState from '..'; // -------------------------------------------------
// CONSTANTS
// -------------------------------------------------

export var ADD_LOCAL_ITEMS = 'ADD_LOCAL_ITEMS';
export var REMOVE_LOCAL_ITEMS = 'REMOVE_LOCAL_ITEMS';
export var UNDO_LOCAL_ITEMS = 'UNDO_LOCAL_ITEMS';
var UPDATE_LOCAL_ITEMS_REQUEST = 'UPDATE_LOCAL_ITEMS_REQUEST';
var UPDATE_LOCAL_ITEMS_FAILURE = 'UPDATE_LOCAL_ITEMS_FAILURE';
var ADD_LOCAL_ITEMS_SUCCESS = 'ADD_LOCAL_ITEMS_SUCCESS';
var REMOVE_LOCAL_ITEMS_SUCCESS = 'REMOVE_LOCAL_ITEMS_SUCCESS';
var UNDO_LOCAL_ITEMS_SUCCESS = 'UNDO_LOCAL_ITEMS_SUCCESS'; // -------------------------------------------------
// ACTIONS
// -------------------------------------------------

export var addLocalItems = function addLocalItems(items) {
  return {
    type: ADD_LOCAL_ITEMS,
    request: handleRequest('post')(items)
  };
};
export var removeLocalItems = function removeLocalItems(items) {
  var forMerge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: REMOVE_LOCAL_ITEMS,
    request: handleRequest('delete')(items),
    forMerge: forMerge
  };
};
export var undoLocalItems = function undoLocalItems(items) {
  return {
    type: UNDO_LOCAL_ITEMS,
    request: handleRequest('put')(items)
  };
};
export var updateLocalItemsRequest = function updateLocalItemsRequest(payload) {
  return {
    type: UPDATE_LOCAL_ITEMS_REQUEST,
    payload: payload
  };
};
export var updateLocalItemsFailure = function updateLocalItemsFailure(error) {
  return {
    type: UPDATE_LOCAL_ITEMS_FAILURE,
    error: error
  };
};
export var addLocalItemsSuccess = function addLocalItemsSuccess(payload) {
  return {
    type: ADD_LOCAL_ITEMS_SUCCESS,
    payload: payload
  };
};
export var removeLocalItemsSuccess = function removeLocalItemsSuccess(payload) {
  return {
    type: REMOVE_LOCAL_ITEMS_SUCCESS,
    payload: payload
  };
};
export var undoLocalItemsSuccess = function undoLocalItemsSuccess(payload) {
  return {
    type: UNDO_LOCAL_ITEMS_SUCCESS,
    payload: payload
  };
}; // -------------------------------------------------
// REDUCER
// -------------------------------------------------

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var newState = cloneDeep(state);

  switch (action.type) {
    case UPDATE_LOCAL_ITEMS_REQUEST:
      newState.ui.isRequesting = false;
      newState.error = null;
      newState.data.wishlists[0].items = newListUpdateItemFlag(newState.data.wishlists[0].items, mapByAttribute(action.payload.items, 'partNumber'), true);
      return newState;

    case UPDATE_LOCAL_ITEMS_FAILURE:
      newState.ui.isRequesting = false;
      newState.error = action.error;
      newState.data.wishlists[0].items = newListUpdateItemFlag(newState.data.wishlists[0].items, mapByAttribute(action.payload.items, 'partNumber'));
      return newState;

    case ADD_LOCAL_ITEMS_SUCCESS:
      newState.ui.isRequesting = false;
      newState.error = null;
      newState.data.wishlists[0].items = newListAddItem(newListUpdateItemFlag(newState.data.wishlists[0].items, mapByAttribute(action.payload.items, 'partNumber')), mapByAttribute(action.payload.items, 'partNumber'));
      return newState;

    case REMOVE_LOCAL_ITEMS_SUCCESS:
      newState.ui.isRequesting = false;
      newState.error = null;
      newState.data.wishlists[0].items = newListRemoveItemFlag(newListUpdateItemFlag(newState.data.wishlists[0].items, mapByAttribute(action.payload.items, 'partNumber')), mapByAttribute(action.payload.items, 'partNumber'));
      return newState;

    case UNDO_LOCAL_ITEMS_SUCCESS:
      newState.ui.isRequesting = false;
      newState.error = null;
      newState.data.wishlists[0].items = newListUndoItem(newListUpdateItemFlag(newState.data.wishlists[0].items, mapByAttribute(action.payload.items, 'partNumber')), mapByAttribute(action.payload.items, 'partNumber'));
      return newState;

    default:
      return state;
  }
});